export const locationIdxByName = (locations, name) => {
  if (!name) {
    return { index: -1, matchCount: 0 };
  }

  let index = -1;
  let matchCount = 0;

  (locations ?? []).forEach((entry, idx) => {
    if (entry?.location !== name) return;

    matchCount += 1;
    if (index === -1) index = idx;
  });

  return { index, matchCount };
};
